// // import React, { useState, useMemo, useEffect } from "react";
// // import { useSelector, useDispatch } from "react-redux";
// // import {
// //   TextField,
// //   Button,
// //   Typography,
// //   Grid,
// //   Select,
// //   MenuItem,
// //   FormControl,
// //   InputLabel,
// //   Chip,
// //   Box,
// //   OutlinedInput,
// //   ListSubheader,
// //   InputAdornment,
// // } from "@mui/material";
// // import MDBox from "components/MDBox";
// // import { toast } from "react-toastify";
// // import { v4 as uuidv4 } from "uuid";
// // import SearchIcon from "@mui/icons-material/Search";
// // import DownloadIcon from "@mui/icons-material/Download"; // <-- Added import
// // import FileSaver from "file-saver"; // <-- Added import

// // const StopForm = ({ stop, onBack, selectedJourney, onJourneyUpdated }) => {
// //   const { data: accountData, students, staff, loading, error } = useSelector((state) => state.apiGetData);
// //   const [searchTerm, setSearchTerm] = useState("");
// //   const dispatch = useDispatch();

// //   const isNewStop = stop?.isNew === true;

// //   const getRollNumber = (accountId) => {
// //     if (!accountId) return "N/A";
// //     const parts = accountId.split("::");
// //     return parts.length > 1 ? parts[1] : accountId;
// //   };

// //   const [formData, setFormData] = useState({
// //     id: stop?.filterId || "",
// //     name: stop?.name || "",
// //     type: stop?.type || "BUS_STOP",
// //     latitude: stop?.latitude || "",
// //     longitude: stop?.longitude || "",
// //     externalHandle: stop?.externalHandle || "",
// //     students: stop?.students || [],
// //   });

// //   const [isSubmitting, setIsSubmitting] = useState(false);
// //   const [dropDownOpen, setDropDownOpen] = useState(false);

// //   // Fallback to empty array to prevent map/filter errors if students/staff is undefined/null
// //   const safeStudents = students || [];
// //   const safeStaff = staff || [];
// //   const safeAccounts = useMemo(
// //     () =>
// //       Object.values(accountData?.accounts || {})
// //         .map((item) => item.account)
// //         .filter(Boolean),
// //     [accountData]
// //   );

// //   // ✅ Combined list: all accounts + students + staff, tagged with role so UI can show "Staff" / "Student"
// //   const safePeople = useMemo(() => {
// //     const peopleById = new Map();

// //     [
// //       ...safeAccounts,
// //       ...safeStudents.map((s) => ({ ...s, role: s.role || "STUDENT" })),
// //       ...safeStaff.map((s) => ({ ...s, role: s.role || "STAFF" })),
// //     ].forEach((person) => {
// //       if (person?.accountId) peopleById.set(person.accountId, person);
// //     });

// //     return Array.from(peopleById.values());
// //   }, [safeAccounts, safeStudents, safeStaff]);

// //   const findPersonByAccountId = (accountId) => {
// //     const roll = getRollNumber(accountId);
// //     return safePeople.find((person) => {
// //       const personRoll = getRollNumber(person.accountId);
// //       return person.accountId === accountId || personRoll === roll;
// //     });
// //   };

// //   const getPersonName = (person) =>
// //     [person?.firstName, person?.lastName].filter(Boolean).join(" ") ||
// //     person?.fullName ||
// //     person?.name ||
// //     person?.accountName ||
// //     "";

// //   const filteredStudents = useMemo(() => {
// //     if (!searchTerm) return safePeople;
// //     const lowerSearch = searchTerm.toLowerCase();
// //     return safePeople.filter((s) => {
// //       const roll = getRollNumber(s.accountId).toLowerCase();
// //       const name = `${s.firstName || ""} ${s.lastName || ""}`.toLowerCase();
// //       return roll.includes(lowerSearch) || name.includes(lowerSearch);
// //     });
// //   }, [safePeople, searchTerm]);

// //   const handleChange = (e) => {
// //     const { name, value } = e.target;
// //     setFormData((prev) => ({ ...prev, [name]: value }));
// //   };

// //   const handleStudentsChange = (event) => {
// //     const value = event.target.value;
// //     setFormData((prev) => ({ ...prev, students: value }));
// //     setDropDownOpen(false);
// //   };

// //   const handleStudentDelete = (idToDelete) => {
// //     setFormData((prev) => ({
// //       ...prev,
// //       students: prev.students.filter((id) => id !== idToDelete),
// //     }));
// //   };

// //   const updateJourneyWithStop = (journey, formData, isNew) => {
// //     const updatedJourney = {
// //       ...journey,
// //       sequence: { ...(journey.sequence || {}) },
// //       stops: { ...(journey.stops || {}) },
// //       filters: { ...(journey.filters || {}) }
// //     };

// //     if (isNew) {
// //       const newFilterId = formData.id || uuidv4();
// //       const newSequenceKey = Object.keys(updatedJourney.sequence).length.toString();

// //       updatedJourney.sequence[newSequenceKey] = newFilterId;
// //       updatedJourney.stops[newFilterId] = [];

// //       updatedJourney.filters[newFilterId] = {
// //         tags: [formData.name, ""],
// //         type: "LocationFilter",
// //         filterId: newFilterId,
// //         data: {
// //           type: formData.type,
// //           location: {
// //             latitude: parseFloat(formData.latitude),
// //             longitude: parseFloat(formData.longitude),
// //           },
// //         },
// //         externalHandle: formData.externalHandle || null,
// //         externalInfo: null,
// //         thingIds: null,
// //         adminOnly: false,
// //         passengers: formData.students.length,
// //         selected: formData.students.length > 0,
// //       };
// //     } else {
// //       if (updatedJourney.filters[formData.id]) {
// //         updatedJourney.filters[formData.id] = {
// //           ...updatedJourney.filters[formData.id],
// //           tags: [formData.name, ""],
// //           data: {
// //             ...updatedJourney.filters[formData.id].data,
// //             type: formData.type,
// //             location: {
// //               latitude: parseFloat(formData.latitude),
// //               longitude: parseFloat(formData.longitude),
// //             },
// //           },
// //           externalHandle: formData.externalHandle || null,
// //           passengers: formData.students.length,
// //           selected: formData.students.length > 0,
// //         };
// //       }
// //     }

// //     const filterId = formData.id || Object.keys(updatedJourney.sequence).slice(-1)[0];

// //     if (formData.students.length > 0) {
// //       updatedJourney.stops[filterId] = formData.students.map((studentId) => {
// //         if (studentId.includes("::")) {
// //           const parts = studentId.split("::");
// //           return `${parts[0]}::${parts[1]}`;
// //         }
// //         return `${studentId}::${studentId.slice(-3)}`;
// //       });
// //     } else {
// //       updatedJourney.stops[filterId] = [];
// //     }

// //     return updatedJourney;
// //   };

// //   const handleSubmit = async () => {
// //     if (!selectedJourney) {
// //       toast.error("No journey selected");
// //       return;
// //     }

// //     setIsSubmitting(true);

// //     try {
// //       const updatedJourney = updateJourneyWithStop(selectedJourney, formData, isNewStop);
// //       const sessionToken = localStorage.getItem("token");

// //       const response = await fetch("https://v3.dhundhoo.com/journey/editStops", {
// //         method: "POST",
// //         headers: {
// //           "Content-Type": "application/json",
// //           "x-dhundhoo-session": sessionToken,
// //         },
// //         body: JSON.stringify(updatedJourney),
// //       });

// //       if (!response.ok) {
// //         throw new Error(`HTTP error! status: ${response.status}`);
// //       }

// //       const result = await response.json();
// //       toast.success(isNewStop ? "Stop added successfully!" : "Stop updated successfully!");

// //       if (onJourneyUpdated) {
// //         onJourneyUpdated(updatedJourney);
// //       }

// //       onBack();
// //     } catch (err) {
// //       console.error("Error saving stop:", err);
// //       toast.error(`Failed to ${isNewStop ? "add" : "update"} stop: ${err.message}`);
// //     } finally {
// //       setIsSubmitting(false);
// //     }
// //   };

// //   const isSafari = () => /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

// //   const onExcelExport = () => {
// //     // Header mein ab sirf ek 'Students' column hai
// //     let data = '"Stop ID","Stop Name","Stop Type","Latitude","Longitude","External Handle","Students"\n';

// //     if (formData.students && formData.students.length > 0) {
// //       // Combined details collect karne ke liye array
// //       const studentDetails = [];

// //       formData.students.forEach((studentId) => {
// //         const student = findPersonByAccountId(studentId);
// //         const roll = getRollNumber(studentId);
// //         const studentName = getPersonName(student);
// //         const roleTag = student?.role === "STAFF" ? " (Staff)" : "";

// //         // Roll aur Name ko ek sath jod kar string banayein
// //         const combinedInfo = `${roll} ${studentName}${roleTag}`.trim();
        
// //         if (combinedInfo) {
// //           studentDetails.push(combinedInfo);
// //         }
// //       });

// //       // Sabhi students ko comma se join karein
// //       const allStudentsString = studentDetails.join(", ");

// //       // Data row mein append karein
// //       data += `"${formData.id}","${formData.name}","${formData.type}","${formData.latitude}","${formData.longitude}","${formData.externalHandle || ""}","${allStudentsString}"\n`;
// //     } else {
// //       // Agar koi student nahi hai
// //       data += `"${formData.id}","${formData.name}","${formData.type}","${formData.latitude}","${formData.longitude}","${formData.externalHandle || ""}",""\n`;
// //     }

// //     let blob = new Blob(["\ufeff", data], {
// //       type: isSafari() ? "application/csv" : "text/csv",
// //     });
// //     const dateStr = new Date().toISOString().split("T")[0];
// //     const fileName = formData.name ? formData.name.replace(/\s+/g, '_') : 'New_Stop';
// //     FileSaver.saveAs(blob, `Stop_Details_${fileName}_${dateStr}.csv`);
// //   };

// //   if (!stop) {
// //     return (
// //       <MDBox sx={{ p: 2 }}>
// //         <Typography variant="h6" color="error">
// //           Error: No stop data provided
// //         </Typography>
// //         <Button variant="outlined" color="secondary" onClick={onBack}>
// //           Back To Map
// //         </Button>
// //       </MDBox>
// //     );
// //   }

// //   return (
// //     <MDBox
// //       sx={{
// //         width: "65vw",
// //         height: "100%",
// //         p: 2,
// //         boxShadow: "2px 0 6px rgba(0,0,0,0.1)",
// //         backgroundColor: "#fff",
// //         overflowY: "auto",
// //       }}
// //     >
// //       <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", mb: 2, position: "relative" }}>
// //         <Typography variant="h6" align="center">
// //           {isNewStop ? "Add New Stop" : "Edit Stop"}
// //         </Typography>

// //         <Button
// //           variant="contained"
// //           color="primary"
// //           startIcon={<DownloadIcon />}
// //           onClick={onExcelExport}
// //           sx={{ color: "#fff", position: "absolute", right: 0 }}
// //         >
// //           Export Details
// //         </Button>
// //       </Box>

// //       <Grid container spacing={2}>
// //         <Grid item xs={12}>
// //           <Typography variant="body2">Stop ID: {formData.id}</Typography>
// //         </Grid>

// //         <Grid item xs={12}>
// //           <TextField
// //             label="Stop Name"
// //             name="name"
// //             value={formData.name}
// //             onChange={handleChange}
// //             fullWidth
// //           />
// //         </Grid>

// //         <Grid item xs={12}>
// //           <FormControl fullWidth>
// //             <InputLabel id="stop-type-label">Stop Type</InputLabel>
// //             <Select
// //               labelId="stop-type-label"
// //               name="type"
// //               value={formData.type}
// //               onChange={handleChange}
// //               label="Stop Type"
// //               sx={{ minHeight: 45 }}
// //               MenuProps={{
// //                 PaperProps: { style: { maxHeight: 300 } },
// //               }}
// //             >
// //               <MenuItem value="BUS_STOP">BUS_STOP</MenuItem>
// //               <MenuItem value="INSTITUTE">INSTITUTE</MenuItem>
// //             </Select>
// //           </FormControl>
// //         </Grid>

// //         <Grid item xs={12}>
// //           <TextField
// //             label="Latitude"
// //             name="latitude"
// //             value={formData.latitude}
// //             onChange={handleChange}
// //             fullWidth
// //           />
// //         </Grid>

// //         <Grid item xs={12}>
// //           <TextField
// //             label="Longitude"
// //             name="longitude"
// //             value={formData.longitude}
// //             onChange={handleChange}
// //             fullWidth
// //           />
// //         </Grid>

// //         <Grid item xs={12}>
// //           <TextField
// //             label="External Handle"
// //             name="externalHandle"
// //             value={formData.externalHandle}
// //             onChange={handleChange}
// //             fullWidth
// //             disabled
// //           />
// //         </Grid>

// //         <Grid item xs={12}>
// //           <FormControl fullWidth>
// //             <InputLabel id="students-select-label">Students & Staff</InputLabel>
// //             <Select
// //               labelId="students-select-label"
// //               multiple
// //               value={formData.students}
// //               onChange={handleStudentsChange}
// //               input={<OutlinedInput label="Students & Staff" />}
// //               open={dropDownOpen}
// //               onOpen={() => setDropDownOpen(true)}
// //               onClose={() => setDropDownOpen(false)}
// //               sx={{
// //                 minHeight: 45,
// //                 "& .MuiSelect-select": {
// //                   display: "flex",
// //                   alignItems: "flex-start",
// //                   flexWrap: "wrap",
// //                   whiteSpace: "normal",
// //                   overflow: "visible",
// //                   height: "auto",
// //                   minHeight: "45px !important",
// //                 }
// //               }}
// //               renderValue={(selected) => (
// //                 <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
// //                   {selected.map((id) => {
// //                     const person = findPersonByAccountId(id);
// //                     const roll = getRollNumber(id);
// //                     const fullName = getPersonName(person);
// //                     return (
// //                       <Chip
// //                         key={id}
// //                         label={`(${roll}) ${fullName}`}
// //                         onDelete={() => handleStudentDelete(id)}
// //                         onMouseDown={(e) => e.stopPropagation()}
// //                         size="small"
// //                         color="secondary"
// //                         sx={{
// //                           height: "auto",
// //                           minHeight: 30,
// //                           maxWidth: "100%",
// //                           marginTop: "5px",
// //                           marginBottom: "5px",
// //                           "& .MuiChip-label": {
// //                             display: "block",
// //                             whiteSpace: "normal",
// //                             overflow: "visible",
// //                             textOverflow: "clip",
// //                             lineHeight: 1.25,
// //                             py: 0.5,
// //                           },
// //                         }}
// //                       />
// //                     );
// //                   })}
// //                 </Box>
// //               )}
// //               MenuProps={{
// //                 PaperProps: { style: { maxHeight: 400 } },
// //               }}
// //             >
// //               <ListSubheader disableSticky>
// //                 <TextField
// //                   size="small"
// //                   autoFocus
// //                   placeholder="Search Roll No or Name..."
// //                   fullWidth
// //                   InputProps={{
// //                     startAdornment: (
// //                       <InputAdornment position="start">
// //                         <SearchIcon />
// //                       </InputAdornment>
// //                     ),
// //                   }}
// //                   onChange={(e) => setSearchTerm(e.target.value)}
// //                   onKeyDown={(e) => e.stopPropagation()}
// //                 />
// //               </ListSubheader>

// //               {loading ? (
// //                 <MenuItem disabled>Loading...</MenuItem>
// //               ) : error ? (
// //                 <MenuItem disabled>Error loading list</MenuItem>
// //               ) : filteredStudents.length > 0 ? (
// //                 filteredStudents.map((student) => (
// //                   <MenuItem key={student.accountId} value={student.accountId}>
// //                     {`(${getRollNumber(student.accountId)}) - ${student.firstName}${student.lastName ? ` ${student.lastName}` : ""}${student.role === "STAFF" ? " — Staff" : ""}`}
// //                   </MenuItem>
// //                 ))
// //               ) : (
// //                 <MenuItem disabled>No students or staff found</MenuItem>
// //               )}
// //             </Select>
// //           </FormControl>
// //         </Grid>
// //       </Grid>

// //       <Grid container spacing={2} sx={{ mt: 2 }}>
// //         <Grid item xs={6}>
// //           <Button
// //             variant="contained"
// //             color="primary"
// //             fullWidth
// //             onClick={handleSubmit}
// //             disabled={isSubmitting}
// //             sx={{ color: '#fff' }}
// //           >
// //             {isSubmitting ? "Saving..." : (isNewStop ? "Add Stop" : "Update Stop")}
// //           </Button>
// //         </Grid>
// //         <Grid item xs={6}>
// //           <Button
// //             variant="outlined"
// //             color="secondary"
// //             fullWidth
// //             onClick={onBack}
// //             disabled={isSubmitting}
// //             style={{ color: 'black' }}
// //           >
// //             Back To Map
// //           </Button>
// //         </Grid>
// //       </Grid>
// //     </MDBox>
// //   );
// // };

// // export default StopForm;
// import React, { useState, useMemo, useEffect } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import {
//   TextField,
//   Button,
//   Typography,
//   Grid,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Chip,
//   Box,
//   OutlinedInput,
//   ListSubheader,
//   InputAdornment,
// } from "@mui/material";
// import MDBox from "components/MDBox";
// import { toast } from "react-toastify";
// import { v4 as uuidv4 } from "uuid";
// import SearchIcon from "@mui/icons-material/Search";
// import DownloadIcon from "@mui/icons-material/Download";
// import FileSaver from "file-saver";

// const normalize = (v) => String(v ?? "").trim().toLowerCase();

// const getRollNumber = (accountId) => {
//   if (!accountId) return "N/A";
//   const parts = String(accountId).split("::");
//   return parts.length > 1 ? parts[1] : String(accountId);
// };

// // Tries every name shape we might get from the API
// const getPersonName = (person) => {
//   if (!person) return "";
//   const first = person.firstName || person.first_name || "";
//   const last = person.lastName || person.last_name || "";
//   const joined = [first, last].filter(Boolean).join(" ").trim();
//   return (
//     joined ||
//     person.fullName ||
//     person.name ||
//     person.accountName ||
//     person.displayName ||
//     person.studentName ||
//     person.staffName ||
//     ""
//   );
// };

// const StopForm = ({ stop, onBack, selectedJourney, onJourneyUpdated }) => {
//   const { data: accountData, students, staff, loading, error } = useSelector((state) => state.apiGetData);
//   const [searchTerm, setSearchTerm] = useState("");
//   const dispatch = useDispatch();

//   const isNewStop = stop?.isNew === true;

//   const [formData, setFormData] = useState({
//     id: stop?.filterId || "",
//     name: stop?.name || "",
//     type: stop?.type || "BUS_STOP",
//     latitude: stop?.latitude || "",
//     longitude: stop?.longitude || "",
//     externalHandle: stop?.externalHandle || "",
//     students: stop?.students || [],
//   });

//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [dropDownOpen, setDropDownOpen] = useState(false);

//   // Fallback to empty arrays to prevent map/filter errors if students/staff is undefined/null
//   const safeStudents = students || [];
//   const safeStaff = staff || [];
//   const safeAccounts = useMemo(
//     () =>
//       Object.values(accountData?.accounts || {})
//         .map((item) => item.account)
//         .filter(Boolean),
//     [accountData]
//   );

//   // Combined list: all accounts + students + staff, tagged with role.
//   // If the same person appears in several lists, merge them so a record
//   // that has a name is never overwritten by one that doesn't.
//   const safePeople = useMemo(() => {
//     const peopleById = new Map();

//     [
//       ...safeAccounts,
//       ...safeStudents.map((s) => ({ ...s, role: s.role || "STUDENT" })),
//       ...safeStaff.map((s) => ({ ...s, role: s.role || "STAFF" })),
//     ].forEach((person) => {
//       if (!person?.accountId) return;
//       const existing = peopleById.get(person.accountId);
//       if (!existing) {
//         peopleById.set(person.accountId, person);
//       } else {
//         const merged = { ...existing };
//         Object.keys(person).forEach((k) => {
//           if (person[k] !== undefined && person[k] !== null && person[k] !== "") {
//             merged[k] = person[k];
//           }
//         });
//         peopleById.set(person.accountId, merged);
//       }
//     });

//     return Array.from(peopleById.values());
//   }, [safeAccounts, safeStudents, safeStaff]);

//   // Fast lookup tables: by full accountId, by roll number, and by other id-like fields
//   const peopleIndex = useMemo(() => {
//     const byId = new Map();
//     const byRoll = new Map();

//     safePeople.forEach((person) => {
//       byId.set(normalize(person.accountId), person);

//       const rolls = [
//         getRollNumber(person.accountId),
//         person.rollNumber,
//         person.rollNo,
//         person.roll_no,
//         person.admissionNumber,
//       ];
//       rolls.forEach((r) => {
//         const key = normalize(r);
//         if (!key || key === "n/a") return;
//         // prefer a record that actually has a name
//         if (!byRoll.has(key) || (!getPersonName(byRoll.get(key)) && getPersonName(person))) {
//           byRoll.set(key, person);
//         }
//       });
//     });

//     return { byId, byRoll };
//   }, [safePeople]);

//   const findPersonByAccountId = (accountId) => {
//     if (!accountId) return undefined;
//     const direct = peopleIndex.byId.get(normalize(accountId));
//     if (direct) return direct;
//     return peopleIndex.byRoll.get(normalize(getRollNumber(accountId)));
//   };

//   // Single place that builds the visible label, used by chips, menu items and CSV
//   const getPersonLabel = (accountId, person) => {
//     const roll = getRollNumber(accountId);
//     const name = getPersonName(person);
//     const staffTag = person?.role === "STAFF" ? " — Staff" : "";
//     return name ? `(${roll}) ${name}${staffTag}` : `(${roll})`;
//   };

//   const filteredStudents = useMemo(() => {
//     if (!searchTerm) return safePeople;
//     const lowerSearch = searchTerm.toLowerCase();
//     return safePeople.filter((s) => {
//       const roll = getRollNumber(s.accountId).toLowerCase();
//       const name = getPersonName(s).toLowerCase();
//       return roll.includes(lowerSearch) || name.includes(lowerSearch);
//     });
//   }, [safePeople, searchTerm]);

//   // Uncomment to debug when names are still missing:
//   // useEffect(() => {
//   //   console.log("people count:", safePeople.length);
//   //   console.log("sample person:", safePeople[0]);
//   //   console.log("selected ids:", formData.students);
//   // }, [safePeople, formData.students]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleStudentsChange = (event) => {
//     const value = event.target.value;
//     setFormData((prev) => ({ ...prev, students: value }));
//     setDropDownOpen(false);
//   };

//   const handleStudentDelete = (idToDelete) => {
//     setFormData((prev) => ({
//       ...prev,
//       students: prev.students.filter((id) => id !== idToDelete),
//     }));
//   };

//   const updateJourneyWithStop = (journey, formData, isNew) => {
//     const updatedJourney = {
//       ...journey,
//       sequence: { ...(journey.sequence || {}) },
//       stops: { ...(journey.stops || {}) },
//       filters: { ...(journey.filters || {}) },
//     };

//     if (isNew) {
//       const newFilterId = formData.id || uuidv4();
//       const newSequenceKey = Object.keys(updatedJourney.sequence).length.toString();

//       updatedJourney.sequence[newSequenceKey] = newFilterId;
//       updatedJourney.stops[newFilterId] = [];

//       updatedJourney.filters[newFilterId] = {
//         tags: [formData.name, ""],
//         type: "LocationFilter",
//         filterId: newFilterId,
//         data: {
//           type: formData.type,
//           location: {
//             latitude: parseFloat(formData.latitude),
//             longitude: parseFloat(formData.longitude),
//           },
//         },
//         externalHandle: formData.externalHandle || null,
//         externalInfo: null,
//         thingIds: null,
//         adminOnly: false,
//         passengers: formData.students.length,
//         selected: formData.students.length > 0,
//       };
//     } else {
//       if (updatedJourney.filters[formData.id]) {
//         updatedJourney.filters[formData.id] = {
//           ...updatedJourney.filters[formData.id],
//           tags: [formData.name, ""],
//           data: {
//             ...updatedJourney.filters[formData.id].data,
//             type: formData.type,
//             location: {
//               latitude: parseFloat(formData.latitude),
//               longitude: parseFloat(formData.longitude),
//             },
//           },
//           externalHandle: formData.externalHandle || null,
//           passengers: formData.students.length,
//           selected: formData.students.length > 0,
//         };
//       }
//     }

//     const filterId = formData.id || Object.keys(updatedJourney.sequence).slice(-1)[0];

//     if (formData.students.length > 0) {
//       updatedJourney.stops[filterId] = formData.students.map((studentId) => {
//         if (studentId.includes("::")) {
//           const parts = studentId.split("::");
//           return `${parts[0]}::${parts[1]}`;
//         }
//         return `${studentId}::${studentId.slice(-3)}`;
//       });
//     } else {
//       updatedJourney.stops[filterId] = [];
//     }

//     return updatedJourney;
//   };

//   const handleSubmit = async () => {
//     if (!selectedJourney) {
//       toast.error("No journey selected");
//       return;
//     }

//     setIsSubmitting(true);

//     try {
//       const updatedJourney = updateJourneyWithStop(selectedJourney, formData, isNewStop);
//       const sessionToken = localStorage.getItem("token");

//       const response = await fetch("https://v3.dhundhoo.com/journey/editStops", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           "x-dhundhoo-session": sessionToken,
//         },
//         body: JSON.stringify(updatedJourney),
//       });

//       if (!response.ok) {
//         throw new Error(`HTTP error! status: ${response.status}`);
//       }

//       await response.json();
//       toast.success(isNewStop ? "Stop added successfully!" : "Stop updated successfully!");

//       if (onJourneyUpdated) {
//         onJourneyUpdated(updatedJourney);
//       }

//       onBack();
//     } catch (err) {
//       console.error("Error saving stop:", err);
//       toast.error(`Failed to ${isNewStop ? "add" : "update"} stop: ${err.message}`);
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const isSafari = () => /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

//   const csvCell = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;

//   const onExcelExport = () => {
//     const header = ["Stop ID", "Stop Name", "Stop Type", "Latitude", "Longitude", "External Handle", "Students"]
//       .map(csvCell)
//       .join(",");

//     const allStudentsString = (formData.students || [])
//       .map((studentId) => getPersonLabel(studentId, findPersonByAccountId(studentId)))
//       .join(", ");

//     const row = [
//       formData.id,
//       formData.name,
//       formData.type,
//       formData.latitude,
//       formData.longitude,
//       formData.externalHandle || "",
//       allStudentsString,
//     ]
//       .map(csvCell)
//       .join(",");

//     const data = `${header}\n${row}\n`;

//     const blob = new Blob(["\ufeff", data], {
//       type: isSafari() ? "application/csv" : "text/csv",
//     });
//     const dateStr = new Date().toISOString().split("T")[0];
//     const fileName = formData.name ? formData.name.replace(/\s+/g, "_") : "New_Stop";
//     FileSaver.saveAs(blob, `Stop_Details_${fileName}_${dateStr}.csv`);
//   };

//   if (!stop) {
//     return (
//       <MDBox sx={{ p: 2 }}>
//         <Typography variant="h6" color="error">
//           Error: No stop data provided
//         </Typography>
//         <Button variant="outlined" color="secondary" onClick={onBack}>
//           Back To Map
//         </Button>
//       </MDBox>
//     );
//   }

//   return (
//     <MDBox
//       sx={{
//         width: "65vw",
//         height: "100%",
//         p: 2,
//         boxShadow: "2px 0 6px rgba(0,0,0,0.1)",
//         backgroundColor: "#fff",
//         overflowY: "auto",
//       }}
//     >
//       <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", mb: 2, position: "relative" }}>
//         <Typography variant="h6" align="center">
//           {isNewStop ? "Add New Stop" : "Edit Stop"}
//         </Typography>

//         <Button
//           variant="contained"
//           color="primary"
//           startIcon={<DownloadIcon />}
//           onClick={onExcelExport}
//           sx={{ color: "#fff", position: "absolute", right: 0 }}
//         >
//           Export Details
//         </Button>
//       </Box>

//       <Grid container spacing={2}>
//         <Grid item xs={12}>
//           <Typography variant="body2">Stop ID: {formData.id}</Typography>
//         </Grid>

//         <Grid item xs={12}>
//           <TextField label="Stop Name" name="name" value={formData.name} onChange={handleChange} fullWidth />
//         </Grid>

//         <Grid item xs={12}>
//           <FormControl fullWidth>
//             <InputLabel id="stop-type-label">Stop Type</InputLabel>
//             <Select
//               labelId="stop-type-label"
//               name="type"
//               value={formData.type}
//               onChange={handleChange}
//               label="Stop Type"
//               sx={{ minHeight: 45 }}
//               MenuProps={{
//                 PaperProps: { style: { maxHeight: 300 } },
//               }}
//             >
//               <MenuItem value="BUS_STOP">BUS_STOP</MenuItem>
//               <MenuItem value="INSTITUTE">INSTITUTE</MenuItem>
//             </Select>
//           </FormControl>
//         </Grid>

//         <Grid item xs={12}>
//           <TextField label="Latitude" name="latitude" value={formData.latitude} onChange={handleChange} fullWidth />
//         </Grid>

//         <Grid item xs={12}>
//           <TextField label="Longitude" name="longitude" value={formData.longitude} onChange={handleChange} fullWidth />
//         </Grid>

//         <Grid item xs={12}>
//           <TextField
//             label="External Handle"
//             name="externalHandle"
//             value={formData.externalHandle}
//             onChange={handleChange}
//             fullWidth
//             disabled
//           />
//         </Grid>

//         <Grid item xs={12}>
//           <FormControl fullWidth>
//             <InputLabel id="students-select-label">Students & Staff</InputLabel>
//             <Select
//               labelId="students-select-label"
//               multiple
//               value={formData.students}
//               onChange={handleStudentsChange}
//               input={<OutlinedInput label="Students & Staff" />}
//               open={dropDownOpen}
//               onOpen={() => setDropDownOpen(true)}
//               onClose={() => setDropDownOpen(false)}
//               sx={{
//                 minHeight: 45,
//                 "& .MuiSelect-select": {
//                   display: "flex",
//                   alignItems: "flex-start",
//                   flexWrap: "wrap",
//                   whiteSpace: "normal",
//                   overflow: "visible",
//                   height: "auto",
//                   minHeight: "45px !important",
//                 },
//               }}
//               renderValue={(selected) => (
//                 <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
//                   {selected.map((id) => {
//                     const person = findPersonByAccountId(id);
//                     return (
//                       <Chip
//                         key={id}
//                         label={getPersonLabel(id, person)}
//                         onDelete={() => handleStudentDelete(id)}
//                         onMouseDown={(e) => e.stopPropagation()}
//                         size="small"
//                         color="secondary"
//                         sx={{
//                           height: "auto",
//                           minHeight: 30,
//                           maxWidth: "100%",
//                           marginTop: "5px",
//                           marginBottom: "5px",
//                           "& .MuiChip-label": {
//                             display: "block",
//                             whiteSpace: "normal",
//                             overflow: "visible",
//                             textOverflow: "clip",
//                             lineHeight: 1.25,
//                             py: 0.5,
//                           },
//                         }}
//                       />
//                     );
//                   })}
//                 </Box>
//               )}
//               MenuProps={{
//                 PaperProps: { style: { maxHeight: 400 } },
//               }}
//             >
//               <ListSubheader disableSticky>
//                 <TextField
//                   size="small"
//                   autoFocus
//                   placeholder="Search Roll No or Name..."
//                   fullWidth
//                   InputProps={{
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <SearchIcon />
//                       </InputAdornment>
//                     ),
//                   }}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                   onKeyDown={(e) => e.stopPropagation()}
//                 />
//               </ListSubheader>

//               {loading ? (
//                 <MenuItem disabled>Loading...</MenuItem>
//               ) : error ? (
//                 <MenuItem disabled>Error loading list</MenuItem>
//               ) : filteredStudents.length > 0 ? (
//                 filteredStudents.map((student) => (
//                   <MenuItem key={student.accountId} value={student.accountId}>
//                     {`(${getRollNumber(student.accountId)}) - ${getPersonName(student) || "Unknown"}${
//                       student.role === "STAFF" ? " — Staff" : ""
//                     }`}
//                   </MenuItem>
//                 ))
//               ) : (
//                 <MenuItem disabled>No students or staff found</MenuItem>
//               )}
//             </Select>
//           </FormControl>
//         </Grid>
//       </Grid>

//       <Grid container spacing={2} sx={{ mt: 2 }}>
//         <Grid item xs={6}>
//           <Button
//             variant="contained"
//             color="primary"
//             fullWidth
//             onClick={handleSubmit}
//             disabled={isSubmitting}
//             sx={{ color: "#fff" }}
//           >
//             {isSubmitting ? "Saving..." : isNewStop ? "Add Stop" : "Update Stop"}
//           </Button>
//         </Grid>
//         <Grid item xs={6}>
//           <Button
//             variant="outlined"
//             color="secondary"
//             fullWidth
//             onClick={onBack}
//             disabled={isSubmitting}
//             style={{ color: "black" }}
//           >
//             Back To Map
//           </Button>
//         </Grid>
//       </Grid>
//     </MDBox>
//   );
// };

// export default StopForm;
// import React, { useState, useMemo, useEffect } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import {
//   TextField,
//   Button,
//   Typography,
//   Grid,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Chip,
//   Box,
//   OutlinedInput,
//   ListSubheader,
//   InputAdornment,
// } from "@mui/material";
// import MDBox from "components/MDBox";
// import { toast } from "react-toastify";
// import { v4 as uuidv4 } from "uuid";
// import SearchIcon from "@mui/icons-material/Search";
// import DownloadIcon from "@mui/icons-material/Download"; // <-- Added import
// import FileSaver from "file-saver"; // <-- Added import

// const StopForm = ({ stop, onBack, selectedJourney, onJourneyUpdated }) => {
//   const { data: accountData, students, staff, loading, error } = useSelector((state) => state.apiGetData);
//   const [searchTerm, setSearchTerm] = useState("");
//   const dispatch = useDispatch();

//   const isNewStop = stop?.isNew === true;

//   const getRollNumber = (accountId) => {
//     if (!accountId) return "N/A";
//     const parts = accountId.split("::");
//     return parts.length > 1 ? parts[1] : accountId;
//   };

//   const [formData, setFormData] = useState({
//     id: stop?.filterId || "",
//     name: stop?.name || "",
//     type: stop?.type || "BUS_STOP",
//     latitude: stop?.latitude || "",
//     longitude: stop?.longitude || "",
//     externalHandle: stop?.externalHandle || "",
//     students: stop?.students || [],
//   });

//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [dropDownOpen, setDropDownOpen] = useState(false);

//   // Fallback to empty array to prevent map/filter errors if students/staff is undefined/null
//   const safeStudents = students || [];
//   const safeStaff = staff || [];
//   const safeAccounts = useMemo(
//     () =>
//       Object.values(accountData?.accounts || {})
//         .map((item) => item.account)
//         .filter(Boolean),
//     [accountData]
//   );

//   // ✅ Combined list: all accounts + students + staff, tagged with role so UI can show "Staff" / "Student"
//   const safePeople = useMemo(() => {
//     const peopleById = new Map();

//     [
//       ...safeAccounts,
//       ...safeStudents.map((s) => ({ ...s, role: s.role || "STUDENT" })),
//       ...safeStaff.map((s) => ({ ...s, role: s.role || "STAFF" })),
//     ].forEach((person) => {
//       if (person?.accountId) peopleById.set(person.accountId, person);
//     });

//     return Array.from(peopleById.values());
//   }, [safeAccounts, safeStudents, safeStaff]);

//   const findPersonByAccountId = (accountId) => {
//     const roll = getRollNumber(accountId);
//     return safePeople.find((person) => {
//       const personRoll = getRollNumber(person.accountId);
//       return person.accountId === accountId || personRoll === roll;
//     });
//   };

//   const getPersonName = (person) =>
//     [person?.firstName, person?.lastName].filter(Boolean).join(" ") ||
//     person?.fullName ||
//     person?.name ||
//     person?.accountName ||
//     "";

//   const filteredStudents = useMemo(() => {
//     if (!searchTerm) return safePeople;
//     const lowerSearch = searchTerm.toLowerCase();
//     return safePeople.filter((s) => {
//       const roll = getRollNumber(s.accountId).toLowerCase();
//       const name = `${s.firstName || ""} ${s.lastName || ""}`.toLowerCase();
//       return roll.includes(lowerSearch) || name.includes(lowerSearch);
//     });
//   }, [safePeople, searchTerm]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleStudentsChange = (event) => {
//     const value = event.target.value;
//     setFormData((prev) => ({ ...prev, students: value }));
//     setDropDownOpen(false);
//   };

//   const handleStudentDelete = (idToDelete) => {
//     setFormData((prev) => ({
//       ...prev,
//       students: prev.students.filter((id) => id !== idToDelete),
//     }));
//   };

//   const updateJourneyWithStop = (journey, formData, isNew) => {
//     const updatedJourney = {
//       ...journey,
//       sequence: { ...(journey.sequence || {}) },
//       stops: { ...(journey.stops || {}) },
//       filters: { ...(journey.filters || {}) }
//     };

//     if (isNew) {
//       const newFilterId = formData.id || uuidv4();
//       const newSequenceKey = Object.keys(updatedJourney.sequence).length.toString();

//       updatedJourney.sequence[newSequenceKey] = newFilterId;
//       updatedJourney.stops[newFilterId] = [];

//       updatedJourney.filters[newFilterId] = {
//         tags: [formData.name, ""],
//         type: "LocationFilter",
//         filterId: newFilterId,
//         data: {
//           type: formData.type,
//           location: {
//             latitude: parseFloat(formData.latitude),
//             longitude: parseFloat(formData.longitude),
//           },
//         },
//         externalHandle: formData.externalHandle || null,
//         externalInfo: null,
//         thingIds: null,
//         adminOnly: false,
//         passengers: formData.students.length,
//         selected: formData.students.length > 0,
//       };
//     } else {
//       if (updatedJourney.filters[formData.id]) {
//         updatedJourney.filters[formData.id] = {
//           ...updatedJourney.filters[formData.id],
//           tags: [formData.name, ""],
//           data: {
//             ...updatedJourney.filters[formData.id].data,
//             type: formData.type,
//             location: {
//               latitude: parseFloat(formData.latitude),
//               longitude: parseFloat(formData.longitude),
//             },
//           },
//           externalHandle: formData.externalHandle || null,
//           passengers: formData.students.length,
//           selected: formData.students.length > 0,
//         };
//       }
//     }

//     const filterId = formData.id || Object.keys(updatedJourney.sequence).slice(-1)[0];

//     if (formData.students.length > 0) {
//       updatedJourney.stops[filterId] = formData.students.map((studentId) => {
//         if (studentId.includes("::")) {
//           const parts = studentId.split("::");
//           return `${parts[0]}::${parts[1]}`;
//         }
//         return `${studentId}::${studentId.slice(-3)}`;
//       });
//     } else {
//       updatedJourney.stops[filterId] = [];
//     }

//     return updatedJourney;
//   };

//   const handleSubmit = async () => {
//     if (!selectedJourney) {
//       toast.error("No journey selected");
//       return;
//     }

//     setIsSubmitting(true);

//     try {
//       const updatedJourney = updateJourneyWithStop(selectedJourney, formData, isNewStop);
//       const sessionToken = localStorage.getItem("token");

//       const response = await fetch("https://v3.dhundhoo.com/journey/editStops", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           "x-dhundhoo-session": sessionToken,
//         },
//         body: JSON.stringify(updatedJourney),
//       });

//       if (!response.ok) {
//         throw new Error(`HTTP error! status: ${response.status}`);
//       }

//       const result = await response.json();
//       toast.success(isNewStop ? "Stop added successfully!" : "Stop updated successfully!");

//       if (onJourneyUpdated) {
//         onJourneyUpdated(updatedJourney);
//       }

//       onBack();
//     } catch (err) {
//       console.error("Error saving stop:", err);
//       toast.error(`Failed to ${isNewStop ? "add" : "update"} stop: ${err.message}`);
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const isSafari = () => /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

//   const onExcelExport = () => {
//     // Header mein ab sirf ek 'Students' column hai
//     let data = '"Stop ID","Stop Name","Stop Type","Latitude","Longitude","External Handle","Students"\n';

//     if (formData.students && formData.students.length > 0) {
//       // Combined details collect karne ke liye array
//       const studentDetails = [];

//       formData.students.forEach((studentId) => {
//         const student = findPersonByAccountId(studentId);
//         const roll = getRollNumber(studentId);
//         const studentName = getPersonName(student);
//         const roleTag = student?.role === "STAFF" ? " (Staff)" : "";

//         // Roll aur Name ko ek sath jod kar string banayein
//         const combinedInfo = `${roll} ${studentName}${roleTag}`.trim();
        
//         if (combinedInfo) {
//           studentDetails.push(combinedInfo);
//         }
//       });

//       // Sabhi students ko comma se join karein
//       const allStudentsString = studentDetails.join(", ");

//       // Data row mein append karein
//       data += `"${formData.id}","${formData.name}","${formData.type}","${formData.latitude}","${formData.longitude}","${formData.externalHandle || ""}","${allStudentsString}"\n`;
//     } else {
//       // Agar koi student nahi hai
//       data += `"${formData.id}","${formData.name}","${formData.type}","${formData.latitude}","${formData.longitude}","${formData.externalHandle || ""}",""\n`;
//     }

//     let blob = new Blob(["\ufeff", data], {
//       type: isSafari() ? "application/csv" : "text/csv",
//     });
//     const dateStr = new Date().toISOString().split("T")[0];
//     const fileName = formData.name ? formData.name.replace(/\s+/g, '_') : 'New_Stop';
//     FileSaver.saveAs(blob, `Stop_Details_${fileName}_${dateStr}.csv`);
//   };

//   if (!stop) {
//     return (
//       <MDBox sx={{ p: 2 }}>
//         <Typography variant="h6" color="error">
//           Error: No stop data provided
//         </Typography>
//         <Button variant="outlined" color="secondary" onClick={onBack}>
//           Back To Map
//         </Button>
//       </MDBox>
//     );
//   }

//   return (
//     <MDBox
//       sx={{
//         width: "65vw",
//         height: "100%",
//         p: 2,
//         boxShadow: "2px 0 6px rgba(0,0,0,0.1)",
//         backgroundColor: "#fff",
//         overflowY: "auto",
//       }}
//     >
//       <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", mb: 2, position: "relative" }}>
//         <Typography variant="h6" align="center">
//           {isNewStop ? "Add New Stop" : "Edit Stop"}
//         </Typography>

//         <Button
//           variant="contained"
//           color="primary"
//           startIcon={<DownloadIcon />}
//           onClick={onExcelExport}
//           sx={{ color: "#fff", position: "absolute", right: 0 }}
//         >
//           Export Details
//         </Button>
//       </Box>

//       <Grid container spacing={2}>
//         <Grid item xs={12}>
//           <Typography variant="body2">Stop ID: {formData.id}</Typography>
//         </Grid>

//         <Grid item xs={12}>
//           <TextField
//             label="Stop Name"
//             name="name"
//             value={formData.name}
//             onChange={handleChange}
//             fullWidth
//           />
//         </Grid>

//         <Grid item xs={12}>
//           <FormControl fullWidth>
//             <InputLabel id="stop-type-label">Stop Type</InputLabel>
//             <Select
//               labelId="stop-type-label"
//               name="type"
//               value={formData.type}
//               onChange={handleChange}
//               label="Stop Type"
//               sx={{ minHeight: 45 }}
//               MenuProps={{
//                 PaperProps: { style: { maxHeight: 300 } },
//               }}
//             >
//               <MenuItem value="BUS_STOP">BUS_STOP</MenuItem>
//               <MenuItem value="INSTITUTE">INSTITUTE</MenuItem>
//             </Select>
//           </FormControl>
//         </Grid>

//         <Grid item xs={12}>
//           <TextField
//             label="Latitude"
//             name="latitude"
//             value={formData.latitude}
//             onChange={handleChange}
//             fullWidth
//           />
//         </Grid>

//         <Grid item xs={12}>
//           <TextField
//             label="Longitude"
//             name="longitude"
//             value={formData.longitude}
//             onChange={handleChange}
//             fullWidth
//           />
//         </Grid>

//         <Grid item xs={12}>
//           <TextField
//             label="External Handle"
//             name="externalHandle"
//             value={formData.externalHandle}
//             onChange={handleChange}
//             fullWidth
//             disabled
//           />
//         </Grid>

//         <Grid item xs={12}>
//           <FormControl fullWidth>
//             <InputLabel id="students-select-label">Students & Staff</InputLabel>
//             <Select
//               labelId="students-select-label"
//               multiple
//               value={formData.students}
//               onChange={handleStudentsChange}
//               input={<OutlinedInput label="Students & Staff" />}
//               open={dropDownOpen}
//               onOpen={() => setDropDownOpen(true)}
//               onClose={() => setDropDownOpen(false)}
//               sx={{
//                 minHeight: 45,
//                 "& .MuiSelect-select": {
//                   display: "flex",
//                   alignItems: "flex-start",
//                   flexWrap: "wrap",
//                   whiteSpace: "normal",
//                   overflow: "visible",
//                   height: "auto",
//                   minHeight: "45px !important",
//                 }
//               }}
//               renderValue={(selected) => (
//                 <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
//                   {selected.map((id) => {
//                     const person = findPersonByAccountId(id);
//                     const roll = getRollNumber(id);
//                     const fullName = getPersonName(person);
//                     return (
//                       <Chip
//                         key={id}
//                         label={`(${roll}) ${fullName}`}
//                         onDelete={() => handleStudentDelete(id)}
//                         onMouseDown={(e) => e.stopPropagation()}
//                         size="small"
//                         color="secondary"
//                         sx={{
//                           height: "auto",
//                           minHeight: 30,
//                           maxWidth: "100%",
//                           marginTop: "5px",
//                           marginBottom: "5px",
//                           "& .MuiChip-label": {
//                             display: "block",
//                             whiteSpace: "normal",
//                             overflow: "visible",
//                             textOverflow: "clip",
//                             lineHeight: 1.25,
//                             py: 0.5,
//                           },
//                         }}
//                       />
//                     );
//                   })}
//                 </Box>
//               )}
//               MenuProps={{
//                 PaperProps: { style: { maxHeight: 400 } },
//               }}
//             >
//               <ListSubheader disableSticky>
//                 <TextField
//                   size="small"
//                   autoFocus
//                   placeholder="Search Roll No or Name..."
//                   fullWidth
//                   InputProps={{
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <SearchIcon />
//                       </InputAdornment>
//                     ),
//                   }}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                   onKeyDown={(e) => e.stopPropagation()}
//                 />
//               </ListSubheader>

//               {loading ? (
//                 <MenuItem disabled>Loading...</MenuItem>
//               ) : error ? (
//                 <MenuItem disabled>Error loading list</MenuItem>
//               ) : filteredStudents.length > 0 ? (
//                 filteredStudents.map((student) => (
//                   <MenuItem key={student.accountId} value={student.accountId}>
//                     {`(${getRollNumber(student.accountId)}) - ${student.firstName}${student.lastName ? ` ${student.lastName}` : ""}${student.role === "STAFF" ? " — Staff" : ""}`}
//                   </MenuItem>
//                 ))
//               ) : (
//                 <MenuItem disabled>No students or staff found</MenuItem>
//               )}
//             </Select>
//           </FormControl>
//         </Grid>
//       </Grid>

//       <Grid container spacing={2} sx={{ mt: 2 }}>
//         <Grid item xs={6}>
//           <Button
//             variant="contained"
//             color="primary"
//             fullWidth
//             onClick={handleSubmit}
//             disabled={isSubmitting}
//             sx={{ color: '#fff' }}
//           >
//             {isSubmitting ? "Saving..." : (isNewStop ? "Add Stop" : "Update Stop")}
//           </Button>
//         </Grid>
//         <Grid item xs={6}>
//           <Button
//             variant="outlined"
//             color="secondary"
//             fullWidth
//             onClick={onBack}
//             disabled={isSubmitting}
//             style={{ color: 'black' }}
//           >
//             Back To Map
//           </Button>
//         </Grid>
//       </Grid>
//     </MDBox>
//   );
// };

// export default StopForm;
import React, { useState, useMemo, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  TextField,
  Button,
  Typography,
  Grid,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Chip,
  Box,
  OutlinedInput,
  ListSubheader,
  InputAdornment,
} from "@mui/material";
import MDBox from "components/MDBox";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
import SearchIcon from "@mui/icons-material/Search";
import DownloadIcon from "@mui/icons-material/Download";
import FileSaver from "file-saver";

const normalize = (v) => String(v ?? "").trim().toLowerCase();

const getRollNumber = (accountId) => {
  if (!accountId) return "N/A";
  const parts = String(accountId).split("::");
  return parts.length > 1 ? parts[1] : String(accountId);
};

const getPersonRollNumbers = (person = {}) => {
  const extra = person.extra || {};
  return [
    getRollNumber(person.accountId),
    person.rollNumber,
    person.rollNo,
    person.roll_no,
    person.admissionNumber,
    person.admissionNo,
    person.admission_no,
    person.externalHandle,
    person.id,
    extra.rollNumber,
    extra.rollNo,
    extra.roll_no,
    extra.admissionNumber,
    extra.admissionNo,
    extra.admission_no,
    extra.externalHandle,
  ];
};

// Tries every name shape we might get from the API
const getPersonName = (person) => {
  if (!person) return "";
  const first = person.firstName || person.first_name || "";
  const last = person.lastName || person.last_name || "";
  const joined = [first, last].filter(Boolean).join(" ").trim();
  return (
    joined ||
    person.fullName ||
    person.name ||
    person.accountName ||
    person.displayName ||
    person.studentName ||
    person.staffName ||
    ""
  );
};

const StopForm = ({ stop, onBack, selectedJourney, onJourneyUpdated }) => {
  const { data: accountData, students, staff, loading, error } = useSelector((state) => state.apiGetData);
  const [searchTerm, setSearchTerm] = useState("");
  const dispatch = useDispatch();

  const isNewStop = stop?.isNew === true;

  const [formData, setFormData] = useState({
    id: stop?.filterId || "",
    name: stop?.name || "",
    type: stop?.type || "BUS_STOP",
    latitude: stop?.latitude || "",
    longitude: stop?.longitude || "",
    externalHandle: stop?.externalHandle || "",
    students: stop?.students || [],
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [dropDownOpen, setDropDownOpen] = useState(false);

  // Fallback to empty arrays to prevent map/filter errors if students/staff is undefined/null
  const safeStudents = students || [];
  const safeStaff = staff || [];
  const safeAccounts = useMemo(
    () =>
      Object.values(accountData?.accounts || {})
        .map((item) => {
          const account = item.account;
          if (!account) return null;

          return {
            ...item,
            ...account,
            extra: {
              ...(item.extra || {}),
              ...(account.extra || {}),
            },
          };
        })
        .filter(Boolean),
    [accountData]
  );

  // Combined list: all accounts + students + staff, tagged with role.
  // If the same person appears in several lists, merge them so a record
  // that has a name is never overwritten by one that doesn't.
  const safePeople = useMemo(() => {
    const peopleById = new Map();

    [
      ...safeAccounts,
      ...safeStudents.map((s) => ({ ...s, role: s.role || "STUDENT" })),
      ...safeStaff.map((s) => ({ ...s, role: s.role || "STAFF" })),
    ].forEach((person) => {
      if (!person?.accountId) return;
      const existing = peopleById.get(person.accountId);
      if (!existing) {
        peopleById.set(person.accountId, person);
      } else {
        const merged = { ...existing };
        Object.keys(person).forEach((k) => {
          if (person[k] !== undefined && person[k] !== null && person[k] !== "") {
            merged[k] = person[k];
          }
        });
        peopleById.set(person.accountId, merged);
      }
    });

    return Array.from(peopleById.values());
  }, [safeAccounts, safeStudents, safeStaff]);

  // Fast lookup tables: by full accountId, by roll number, and by other id-like fields
  const peopleIndex = useMemo(() => {
    const byId = new Map();
    const byRoll = new Map();

    safePeople.forEach((person) => {
      [
        person.accountId,
        person.id,
        person.externalHandle,
        person.accountId && getRollNumber(person.accountId),
      ].forEach((id) => {
        const key = normalize(id);
        if (key) byId.set(key, person);
      });

      getPersonRollNumbers(person).forEach((r) => {
        const key = normalize(r);
        if (!key || key === "n/a") return;
        // prefer a record that actually has a name
        if (!byRoll.has(key) || (!getPersonName(byRoll.get(key)) && getPersonName(person))) {
          byRoll.set(key, person);
        }
      });
    });

    return { byId, byRoll };
  }, [safePeople]);

  const findPersonByAccountId = (accountId) => {
    if (!accountId) return undefined;
    const candidates = [
      accountId,
      getRollNumber(accountId),
      String(accountId).split("::")[0],
      String(accountId).split("::").slice(1).join("::"),
    ];

    for (const candidate of candidates) {
      const key = normalize(candidate);
      if (!key) continue;
      const direct = peopleIndex.byId.get(key) || peopleIndex.byRoll.get(key);
      if (direct) return direct;
    }

    return undefined;
  };

  // Single place that builds the visible label, used by chips, menu items and CSV
  const getPersonLabel = (accountId, person) => {
    const roll = getRollNumber(accountId);
    const name = getPersonName(person);
    const staffTag = person?.role === "STAFF" ? " — Staff" : "";
    return name ? `(${roll}) ${name}${staffTag}` : `(${roll})`;
  };

  const filteredStudents = useMemo(() => {
    if (!searchTerm) return safePeople;
    const lowerSearch = searchTerm.toLowerCase();
    return safePeople.filter((s) => {
      const roll = getRollNumber(s.accountId).toLowerCase();
      const name = getPersonName(s).toLowerCase();
      return roll.includes(lowerSearch) || name.includes(lowerSearch);
    });
  }, [safePeople, searchTerm]);

  // Uncomment to debug when names are still missing:
  // useEffect(() => {
  //   console.log("people count:", safePeople.length);
  //   console.log("sample person:", safePeople[0]);
  //   console.log("selected ids:", formData.students);
  // }, [safePeople, formData.students]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleStudentsChange = (event) => {
    const value = event.target.value;
    setFormData((prev) => ({ ...prev, students: value }));
    setDropDownOpen(false);
  };

  const handleStudentDelete = (idToDelete) => {
    setFormData((prev) => ({
      ...prev,
      students: prev.students.filter((id) => id !== idToDelete),
    }));
  };

  const updateJourneyWithStop = (journey, formData, isNew) => {
    const updatedJourney = {
      ...journey,
      sequence: { ...(journey.sequence || {}) },
      stops: { ...(journey.stops || {}) },
      filters: { ...(journey.filters || {}) },
    };

    if (isNew) {
      const newFilterId = formData.id || uuidv4();
      const newSequenceKey = Object.keys(updatedJourney.sequence).length.toString();

      updatedJourney.sequence[newSequenceKey] = newFilterId;
      updatedJourney.stops[newFilterId] = [];

      updatedJourney.filters[newFilterId] = {
        tags: [formData.name, ""],
        type: "LocationFilter",
        filterId: newFilterId,
        data: {
          type: formData.type,
          location: {
            latitude: parseFloat(formData.latitude),
            longitude: parseFloat(formData.longitude),
          },
        },
        externalHandle: formData.externalHandle || null,
        externalInfo: null,
        thingIds: null,
        adminOnly: false,
        passengers: formData.students.length,
        selected: formData.students.length > 0,
      };
    } else {
      if (updatedJourney.filters[formData.id]) {
        updatedJourney.filters[formData.id] = {
          ...updatedJourney.filters[formData.id],
          tags: [formData.name, ""],
          data: {
            ...updatedJourney.filters[formData.id].data,
            type: formData.type,
            location: {
              latitude: parseFloat(formData.latitude),
              longitude: parseFloat(formData.longitude),
            },
          },
          externalHandle: formData.externalHandle || null,
          passengers: formData.students.length,
          selected: formData.students.length > 0,
        };
      }
    }

    const filterId = formData.id || Object.keys(updatedJourney.sequence).slice(-1)[0];

    if (formData.students.length > 0) {
      updatedJourney.stops[filterId] = formData.students.map((studentId) => {
        if (studentId.includes("::")) {
          const parts = studentId.split("::");
          return `${parts[0]}::${parts[1]}`;
        }
        return `${studentId}::${studentId.slice(-3)}`;
      });
    } else {
      updatedJourney.stops[filterId] = [];
    }

    return updatedJourney;
  };

  const handleSubmit = async () => {
    if (!selectedJourney) {
      toast.error("No journey selected");
      return;
    }

    setIsSubmitting(true);

    try {
      const updatedJourney = updateJourneyWithStop(selectedJourney, formData, isNewStop);
      const sessionToken = localStorage.getItem("token");

      const response = await fetch("https://v3.dhundhoo.com/journey/editStops", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-dhundhoo-session": sessionToken,
        },
        body: JSON.stringify(updatedJourney),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      await response.json();
      toast.success(isNewStop ? "Stop added successfully!" : "Stop updated successfully!");

      if (onJourneyUpdated) {
        onJourneyUpdated(updatedJourney);
      }

      onBack();
    } catch (err) {
      console.error("Error saving stop:", err);
      toast.error(`Failed to ${isNewStop ? "add" : "update"} stop: ${err.message}`);
    } finally {
      setIsSubmitting(false);
    }
  };

  const isSafari = () => /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  const csvCell = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;

  const onExcelExport = () => {
    const header = ["Stop ID", "Stop Name", "Stop Type", "Latitude", "Longitude", "External Handle", "Students"]
      .map(csvCell)
      .join(",");

    const allStudentsString = (formData.students || [])
      .map((studentId) => getPersonLabel(studentId, findPersonByAccountId(studentId)))
      .join(", ");

    const row = [
      formData.id,
      formData.name,
      formData.type,
      formData.latitude,
      formData.longitude,
      formData.externalHandle || "",
      allStudentsString,
    ]
      .map(csvCell)
      .join(",");

    const data = `${header}\n${row}\n`;

    const blob = new Blob(["\ufeff", data], {
      type: isSafari() ? "application/csv" : "text/csv",
    });
    const dateStr = new Date().toISOString().split("T")[0];
    const fileName = formData.name ? formData.name.replace(/\s+/g, "_") : "New_Stop";
    FileSaver.saveAs(blob, `Stop_Details_${fileName}_${dateStr}.csv`);
  };

  if (!stop) {
    return (
      <MDBox sx={{ p: 2 }}>
        <Typography variant="h6" color="error">
          Error: No stop data provided
        </Typography>
        <Button variant="outlined" color="secondary" onClick={onBack}>
          Back To Map
        </Button>
      </MDBox>
    );
  }

  return (
    <MDBox
      sx={{
        width: "65vw",
        height: "100%",
        p: 2,
        boxShadow: "2px 0 6px rgba(0,0,0,0.1)",
        backgroundColor: "#fff",
        overflowY: "auto",
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", mb: 2, position: "relative" }}>
        <Typography variant="h6" align="center">
          {isNewStop ? "Add New Stop" : "Edit Stop"}
        </Typography>

        <Button
          variant="contained"
          color="primary"
          startIcon={<DownloadIcon />}
          onClick={onExcelExport}
          sx={{ color: "#fff", position: "absolute", right: 0 }}
        >
          Export Details
        </Button>
      </Box>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="body2">Stop ID: {formData.id}</Typography>
        </Grid>

        <Grid item xs={12}>
          <TextField label="Stop Name" name="name" value={formData.name} onChange={handleChange} fullWidth />
        </Grid>

        <Grid item xs={12}>
          <FormControl fullWidth>
            <InputLabel id="stop-type-label">Stop Type</InputLabel>
            <Select
              labelId="stop-type-label"
              name="type"
              value={formData.type}
              onChange={handleChange}
              label="Stop Type"
              sx={{ minHeight: 45 }}
              MenuProps={{
                PaperProps: { style: { maxHeight: 300 } },
              }}
            >
              <MenuItem value="BUS_STOP">BUS_STOP</MenuItem>
              <MenuItem value="INSTITUTE">INSTITUTE</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12}>
          <TextField label="Latitude" name="latitude" value={formData.latitude} onChange={handleChange} fullWidth />
        </Grid>

        <Grid item xs={12}>
          <TextField label="Longitude" name="longitude" value={formData.longitude} onChange={handleChange} fullWidth />
        </Grid>

        <Grid item xs={12}>
          <TextField
            label="External Handle"
            name="externalHandle"
            value={formData.externalHandle}
            onChange={handleChange}
            fullWidth
            disabled
          />
        </Grid>

        <Grid item xs={12}>
          <FormControl fullWidth>
            <InputLabel id="students-select-label">Students & Staff</InputLabel>
            <Select
              labelId="students-select-label"
              multiple
              value={formData.students}
              onChange={handleStudentsChange}
              input={<OutlinedInput label="Students & Staff" />}
              open={dropDownOpen}
              onOpen={() => setDropDownOpen(true)}
              onClose={() => setDropDownOpen(false)}
              sx={{
                minHeight: 45,
                "& .MuiSelect-select": {
                  display: "flex",
                  alignItems: "flex-start",
                  flexWrap: "wrap",
                  whiteSpace: "normal",
                  overflow: "visible",
                  height: "auto",
                  minHeight: "45px !important",
                },
              }}
              renderValue={(selected) => (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                  {selected.map((id) => {
                    const person = findPersonByAccountId(id);
                    return (
                      <Chip
                        key={id}
                        label={getPersonLabel(id, person)}
                        onDelete={() => handleStudentDelete(id)}
                        onMouseDown={(e) => e.stopPropagation()}
                        size="small"
                        color="secondary"
                        sx={{
                          height: "auto",
                          minHeight: 30,
                          maxWidth: "100%",
                          marginTop: "5px",
                          marginBottom: "5px",
                          "& .MuiChip-label": {
                            display: "block",
                            whiteSpace: "normal",
                            overflow: "visible",
                            textOverflow: "clip",
                            lineHeight: 1.25,
                            py: 0.5,
                          },
                        }}
                      />
                    );
                  })}
                </Box>
              )}
              MenuProps={{
                PaperProps: { style: { maxHeight: 400 } },
              }}
            >
              <ListSubheader disableSticky>
                <TextField
                  size="small"
                  autoFocus
                  placeholder="Search Roll No or Name..."
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  onKeyDown={(e) => e.stopPropagation()}
                />
              </ListSubheader>

              {loading ? (
                <MenuItem disabled>Loading...</MenuItem>
              ) : error ? (
                <MenuItem disabled>Error loading list</MenuItem>
              ) : filteredStudents.length > 0 ? (
                filteredStudents.map((student) => (
                  <MenuItem key={student.accountId} value={student.accountId}>
                    {`(${getRollNumber(student.accountId)}) - ${getPersonName(student) || "Unknown"}${
                      student.role === "STAFF" ? " — Staff" : ""
                    }`}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No students or staff found</MenuItem>
              )}
            </Select>
          </FormControl>
        </Grid>
      </Grid>

      <Grid container spacing={2} sx={{ mt: 2 }}>
        <Grid item xs={6}>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={handleSubmit}
            disabled={isSubmitting}
            sx={{ color: "#fff" }}
          >
            {isSubmitting ? "Saving..." : isNewStop ? "Add Stop" : "Update Stop"}
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Button
            variant="outlined"
            color="secondary"
            fullWidth
            onClick={onBack}
            disabled={isSubmitting}
            style={{ color: "black" }}
          >
            Back To Map
          </Button>
        </Grid>
      </Grid>
    </MDBox>
  );
};

export default StopForm;